import { FC, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { Container, Stack, Typography } from '@mui/material';

import { useRouter } from '@cvt/routing';
import { useDictionary } from '@cvt/hooks/useDictionary';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { BoxWell } from '@shared/components/BoxWell';

import { PreferenceVersionHistory } from '@modules/Users/partials/PreferenceVersionHistory';

import { ValuesVersionTabs } from '../partials/ValuesVersionTabs';
import { CurrentValues } from '../partials/CurrentValues';


export const Values: FC = () => {
  const router = useRouter();
  const dictionary = useDictionary();

  return (
    <Container maxWidth="md" sx={{ mt: 2 }} disableGutters>
      <BoxWell sx={{ px: 3, py: 4 }}>
        <Stack gap={4}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack spacing={2}>
              <Typography variant="h4" component="h1" fontWeight={600} fontSize={{ xs: 24, sm: 30 }}>
                {dictionary.values.title}
              </Typography>
              <Typography variant="body1" fontSize={16} color="text.secondary" fontWeight={500}>
                {dictionary.values.subtitle}
              </Typography>
            </Stack>
          </Stack>

          <ValuesVersionTabs/>

          <ErrorBoundary>
            <Suspense fallback={<BodyLoading height="100%"/>}>
              <Routes>
                <Route
                  path="/current"
                  element={<CurrentValues/>}
                />
                <Route
                  path="/history"
                  element={
                    <ErrorBoundary message={dictionary.preferences.versionSummary.emptyHistory}>
                      <PreferenceVersionHistory description={dictionary.values.versionHistoryDescription}/>
                    </ErrorBoundary>
                  }
                />
                <Route path="*" element={<Navigate to={router.values.current.path} replace/>}/>
              </Routes>
            </Suspense>
          </ErrorBoundary>

        </Stack>
      </BoxWell>
    </Container>
  );
};